<template>
  <v-menu open-on-hover bottom :offset-y="offsetMode" v-if="!isHidden">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon medium>{{iconContent}}</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item v-for="(item, index) in childrenList" :key="index" @click="getActiveRouter(item.path)">
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "RyouMenu",
  props: {
    offsetMode: {
      type: Boolean,
      required: false,
      default: true
    },
    isHidden: {
      type: Boolean,
      required: false,
      default: false
    },
    iconColor: {
      type: String,
      required: false,
      default: ""
    },
    iconContent: {
      type: String,
      required: true,
      default: ""
    },
    childrenList: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    getActiveRouter(router) {
      this.$router.push(router);
    }
  }
};
</script>

<style>
</style>

